import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { BuildingIcon } from "../core/icons/Icons";
import { InputLabel } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";

export const IncreaseCurrentElectricBusinessDemandForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<
        ChangeNames.INCREASE_CURRENT_ELECTRIC_BUSINESS_DEMAND
    >();

    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<BuildingIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gewerbeleistung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Geben Sie die bestehende Gewerbeleistung an. Diese Leistung erhalten Sie
                            ggf. von Ihrem Elektroinstallateur.
                        </p>
                    </Fragment>
                }
                detailCondition={true}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Gewerbeleistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.increaseCurrentElectricBusinessDemand.value.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseCurrentElectricBusinessDemand.value.unit}
                            value={
                                values.increaseCurrentElectricBusinessDemand.value.amount.num || ""
                            }
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.increaseCurrentElectricBusinessDemand.value.amount.num =
                                        v.floatValue || null;
                                })
                            }
                            error={
                                values.increaseCurrentElectricBusinessDemand.error ? true : false
                            }
                        />
                        <br />
                        <FormControlLabel
                            style={{ marginBottom: 24 }}
                            isCheckBox={true}
                            control={
                                <Checkbox
                                    value="ja"
                                    checked={
                                        values.increaseCurrentElectricBusinessDemand.value.notKnown
                                    }
                                    onChange={(event, checked) =>
                                        setValues(values => {
                                            values.increaseCurrentElectricBusinessDemand.value.notKnown = checked;
                                        })
                                    }
                                />
                            }
                            label="Leistungswert nicht bekannt"
                            error={false}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
